export const BASE_URL = `${window.location.origin}`;
